module.exports = __webpack_public_path__ + "static/img/ld.7f4a250a.png";